import { memo } from "react";
import { classNames } from "../../helpers/classNames";
import { useFormatCurrency } from "../../hooks/useFormatCurrency";
import "./Tabs.scss";

const Tabs = ({ tabs, selectedTab, onChange, variant, backgroundColor, isMultipleRace }) => {
  const formatCurrency = useFormatCurrency();
  if (!tabs || !Array.isArray(tabs) || tabs?.length <= 0) {
    return null;
  }
  return (
    <div style={{ backgroundColor: backgroundColor ?? undefined }} className={classNames('tabs', `tabs--${variant || 'primary'}` )}>
      {tabs.map((tab) => (
        <div
          key={tab.value}
          onClick={() => onChange(tab.value)}
          className={classNames("tabs__tab-item", {
            "tabs__tab-item--selected": tab.value === selectedTab,
          })}
        >
          {isMultipleRace ? (
              <>
                <img src={tab.imgSrc || '/static/images/race.webp'} alt={tab.label} height={75} />
                <p>
                  <span className="name">{tab.label}</span>
                  <span className="prizepool">{formatCurrency(tab.prizePool, tab.currency)}</span>
                </p>
              </>
          ) :  <span className="tabs__tab">{tab.label}</span> }
        </div>
      ))}
    </div>
  );
};

export default memo(Tabs);
